import { Injectable } from '@angular/core';

import { AlertController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { AlertButton } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';

export enum AlertDialogButtonClick {
  OK = 'OK',
  CANCEL = 'CANCEL',
}

@Injectable()
export class AlertService {
  constructor(
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private translate: TranslateService
  ) {}

  //  ***  TOASTS  ***

  async openMessageToast(toastMessage: string, header?: string) {
    if (!header) {
      header = 'Nachricht';
    }
    const toast = await this.toastCtrl.create({
      color: 'primary',
      header: header,
      message: toastMessage,
      duration: 2000,
    });
    toast.present();
  }

  async openAlertToast(error_message: string, duration?: number, color?: string) {
    const toast = await this.toastCtrl.create({
      header: this.translate.instant('WARNING'),
      color: color || 'warning',
      message: error_message,
      duration: duration,
    });
    toast.present();
  }

  async openNoticeToast(error_message: string, duration?: number, color?: string) {
    const toast = await this.toastCtrl.create({
      header: this.translate.instant('NOTICE'),
      color: color || 'light',
      message: error_message,
      duration: duration,
    });
    toast.present();
  }

  async openConfirmAlertToast(error_message: string) {
    const toast = await this.toastCtrl.create({
      header: 'Warnung',
      color: 'warning',
      message: error_message,
      buttons: [
        {
          side: 'end',
          text: 'OK',
          // icon: 'alert-circle-outline',
          handler: () => {
            console.log('ende');
          },
        },
        {
          side: 'end',
          text: 'Ignore',
          role: 'cancel',
          handler: () => {
            console.log('close');
          },
        },
      ],
    });
    toast.present();
  }

  // ***  ALERTS  ***

  presentNotificationAlert(): Promise<AlertDialogButtonClick> {
    return this.presentAlert('Ist so', 'balblabla', 'OK');
  }

  presentConfirmAlert(header: string, message: string): Promise<AlertDialogButtonClick> {
    return this.presentAlert(header, message, 'OK', this.translate.instant('CANCEL'));
  }

  presentError(message: string): Promise<AlertDialogButtonClick> {
    return this.presentAlert('ERROR', message, 'OK', this.translate.instant('CANCEL'));
  }

  private presentAlert(header: string, message: string, okButtonText: string, cancelButtonText?: string): Promise<AlertDialogButtonClick> {
    return new Promise<AlertDialogButtonClick>((resolve, reject) => {
      let buttons: AlertButton[] = [];
      // ok button

      if (cancelButtonText) {
        buttons.push({
          text: cancelButtonText,
          role: 'cancel',
          cssClass: 'secondary',
          //id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
            resolve(AlertDialogButtonClick.CANCEL);
          },
        });
      }
      buttons.push({
        text: okButtonText,
        //id: 'confirm-button',
        handler: () => {
          console.log('Confirm Okay');
          resolve(AlertDialogButtonClick.OK);
        },
      });

      this.alertCtrl
        .create({
          cssClass: 'my-custom-class',
          header: header,
          message: message,
          buttons: buttons,
        })
        .then((alert) => {
          alert.present();
        });
    });
  }
}
